// extracted by mini-css-extract-plugin
module.exports = {"MostRead__root":"_7Bw3","MostRead__root_mobile":"abS7","MostRead__link":"nwWE"};